export default __webpack_public_path__ + "static/media/myPicM.68e3f2a1.JPG";